// src/components/TopBar.js
import React, { useState } from 'react';
import { Box, Container, TextField, InputAdornment, Typography, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link, useNavigate } from 'react-router-dom';

const TopBar = () => {
  const [q, setQ] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    const term = q.trim();
    navigate(term ? `/urunler?q=${encodeURIComponent(term)}` : '/urunler');
  };

  return (
    <Box sx={{ backgroundColor: '#2a2a2a', py: 1.5, boxShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>

          {/* Sol: Logo */}
          <Box sx={{ flexShrink: 0 }}>
            <Link to="/">
              <Box sx={{ backgroundColor: 'white', borderRadius: '8px', px: 1.5, py: 0.5, display: 'inline-flex', alignItems: 'center' }}>
                <img
                  src="/logo.png"
                  alt="İremOto Logo"
                  style={{ height: '42px', cursor: 'pointer', display: 'block' }}
                />
              </Box>
            </Link>
          </Box>

          {/* Orta: Arama */}
          <Box component="form" onSubmit={handleSearch} sx={{ flexGrow: 1, mx: { xs: 1, md: 3 } }}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              placeholder="Ürün veya OEM kodu ara..."
              value={q}
              onChange={(e) => setQ(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton type="submit" size="small" aria-label="Ara" sx={{ p: 0.5 }}>
                      <SearchIcon sx={{ color: '#aaa' }} />
                    </IconButton>
                  </InputAdornment>
                ),
                sx: {
                  backgroundColor: '#2a2a2a',
                  borderRadius: '24px',
                  color: 'white',
                  '& fieldset': { border: '1px solid #444' },
                  '&:hover fieldset': { borderColor: '#f08a0c !important' },
                  '&.Mui-focused fieldset': { borderColor: '#f08a0c !important' },
                  input: { color: 'white', '&::placeholder': { color: '#888' } },
                },
              }}
            />
          </Box>

          {/* Sağ: İletişim bilgileri */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'column', gap: 0.3, flexShrink: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <PhoneIcon sx={{ fontSize: 16, color: '#f08a0c' }} />
              <Typography variant="body2" sx={{ color: 'white', fontWeight: 600 }}>
                0312 395 22 25
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <LocationOnIcon sx={{ fontSize: 16, color: '#f08a0c' }} />
              <Typography variant="caption" sx={{ color: '#bbb' }}>
                Yenimahalle / ANKARA
              </Typography>
            </Box>
          </Box>

        </Box>
      </Container>
    </Box>
  );
};

export default TopBar;
